<template>
  <v-row>
    <v-col>
      <div v-if="!showWindow">
        <h1 class="not-found__name">404</h1>
        <span class="not-found__text">Страница не найдена</span>
        <div class="not-found__btn-container">
          <v-btn class="green-button white--text mt-6" @click="goBack()">На главную</v-btn>
        </div>
        <div class="mt-4 helvetica-medium mr-3 fs-18 mt-1">
          <v-text-field v-model="inputCode" />
        </div>
      </div>
      <div v-if="showWindow">
        <div class="tes-card__title d-flex">Проверка функционала ЕСИА</div>
        <div class="tes-card__title font-italic d-flex">
          Здесь вы можете проверить работу функционала ЕСИА
        </div>
        <v-row>
          <div class="form-border mt-5">
            <div class="form-buttons">
              <span class="red--text mt-2 ml-10"><span class="blue--text">ГОС</span>УСЛУГИ</span>
            </div>
            <div class="form-buttons">
              <v-btn
                @click="doLoginESIA()"
                dark
                class="green-button white--text mt-6 mb-2"
                width="320"
                large
                :loading="loading"
                >Войти через ЕСИА
              </v-btn>
            </div>
          </div>
        </v-row>

        <h3 class="mb-4">Оплата услуг</h3>

        <v-text-field
          v-model="personalAccount"
          label="Номер лицевого счета"
          outlined
          dense
          class="mb-4"
          style="max-width: 400px;"
          :error-messages="accountError"
          @input="accountError = ''"
        />

        <v-text-field
          v-model="amountToPay"
          label="Сумма к оплате"
          outlined
          dense
          type="number"
          class="mb-4"
          style="max-width: 400px;"
          prefix="₽"
          :error-messages="amountError"
          @input="amountError = ''"
        />

        <v-btn
          @click="doPay"
          color="primary"
          class="green-button white--text"
          :loading="loading"
          :disabled="!personalAccount || !amountToPay || loading"
        >
          {{ loading ? "Загрузка..." : "Оплатить" }}
        </v-btn>
      </div>

      <modal-payment
        v-if="showModalPayment"
        v-model="showModalPayment"
        :toPay="sumPay"
        :personalAccount="personalAccount"
        :idAccount="idAccount"
      />
      <modal-account-found-error v-if="showWindowError" v-model="showWindowError" />
    </v-col>
  </v-row>
</template>
<script>
import GuestReadingInstructions from "@/components/guest/GuestReadingInstructions";
import { mapState, mapGetters } from "vuex";
import { AxiosWrapper } from "../../assets/api/AxiosWrapper";
import ModalAccountFoundError from "../../components/modals/ModalAccountFoundError.vue";
import ModalPayment from "../../components/modals/ModalPaymentForComission";
// import ModalPaymentEpc from "../../components/modals/ModalPayment.vue";

export default {
  layout: "guest",
  name: "guest-payments",
  data: () => ({
    inputCode: "",
    showWindow: false,
    personalAccount: "",
    sumPay: "",
    loading: false,
    idAccount: "",
    showWindowError: false,
    showModalPayment: false,
    showModalPaymentEpc: false,
    // Данные для деталей платежа
    amountToPay: "",
    accountError: "",
    amountError: "",
    providers: [],
    valueByPrincipal: {},
    userEmail: "",
    userPhone: ""
  }),
  components: {
    ModalAccountFoundError,
    ModalPayment
    // ModalPaymentEpc
  },
  computed: {
    ...mapState("account", ["selectedAccount"]),
    ...mapState("payments", ["currentReceipt"]),
    ...mapGetters("locale", ["currentLocale"]),

    totalToPay() {
      let sum = 0;
      for (let [key, value] of Object.entries(this.valueByPrincipal)) {
        sum = (sum * 100 + value * 100) / 100;
      }
      return parseFloat(sum.toFixed(2));
    },

    payDetails() {
      if (this.providers && this.providers.length > 0) {
        return this.providers.map(provider => ({
          principalCode: parseInt(provider.principalCode) || 0,
          toPay: parseFloat(this.valueByPrincipal[provider.principalCode]) || 0
        }));
      } else {
        return [
          {
            principalCode: 0,
            toPay: parseFloat(this.amountToPay) || 0
          }
        ];
      }
    }
  },
  methods: {
    goBack() {
      if (this.inputCode === "testes7") {
        this.showWindow = true;
      } else {
        this.$router.push({ path: "/authorization" });
      }
    },
    getAccount() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.showWindowError = false;

        this.$store
          .dispatch("guest/getAccount", {
            ls: this.personalAccount
          })
          .then(response => {
            if (response.success && response.isExist) {
              this.idAccount = response.guid;
              if (response.email) this.userEmail = response.email;
              if (response.phone) this.userPhone = response.phone;
              resolve(true);
            } else {
              this.showWindowError = true;
              this.$store.commit("common/ADD_ALERT", {
                text: "Лицевой счет не найден. Проверьте правильность ввода.",
                type: "error"
              });
              resolve(false);
            }
          })
          .catch(err => {
            console.error(err);
            this.$store.commit("common/ADD_ALERT", {
              text: "Произошла ошибка при проверке лицевого счета",
              type: "error"
            });
            reject(err);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    async doPay() {
      console.log("DO-PAY");

      const amount = parseFloat(this.amountToPay);
      if (isNaN(amount) || amount <= 0) {
        this.$store.commit("common/ADD_ALERT", {
          text: "Введите корректную сумму",
          type: "error"
        });
        return;
      }

      if (!this.personalAccount) {
        this.$store.commit("common/ADD_ALERT", {
          text: "Введите номер лицевого счета",
          type: "error"
        });
        return;
      }

      const isAccountFound = await this.getAccount();
      if (!isAccountFound) {
        console.log("счет не найден");

        return; // счет не найден
      }

      // 4. Формируем данные для PayDigitRUB
      const payData = {
        personalAccount: this.personalAccount,
        idAccount: this.idAccount,
        email: this.userEmail || "",
        phone: this.userPhone || "",
        amount: amount
      };

      console.log("Данные на бэкенд (PayDigitRUB):", JSON.stringify(payData, null, 2));

      this.processPayment(payData);
    },
    processPayment(payData) {
      this.loading = true;

      AxiosWrapper.post("GetBankUrlDigital", payData)
        .then(response => {
          console.log("Ответ с бэка:", response.data);

          if (response.data && response.data.success) {
            console.log("Платеж успешно создан!");

            const paymentLink = response.data.url;
            if (paymentLink) {
              console.log("URL для оплаты:", paymentLink);

              // Редирект на страницу банка

              // window.open(paymentLink, "_top");
            } else {
              this.$store.commit("common/ADD_ALERT", {
                text: "Не удалось получить ссылку для оплаты",
                type: "error"
              });
            }
          } else {
            const errorMsg = response.data.message || "Неизвестная ошибка";
            console.log("Ошибка:", errorMsg);
            this.$store.commit("common/ADD_ALERT", {
              text: errorMsg,
              type: "error"
            });
          }
        })
        .catch(err => {
          console.error("Ошибка запроса:", err);
          this.$store.commit("common/ADD_ALERT", {
            text: err.message || "Произошла ошибка при оплате",
            type: "error"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    doLoginESIA() {
      this.loading = true;

      this.$store
        .dispatch("account/getEsiaURL")
        .then(response => {
          if (response.data.success) {
            location.href = response.data.url;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    GetBankUrl() {
      this.loading = true;
      let postData = {
        appVersion: "LKFL",
        personalAccount: this.personalAccount,
        idAccount: this.idAccount,
        paySum: this.sumPay
      };

      AxiosWrapper.post("GetBankUrl", postData)
        .then(response => {
          if (response.data.success) {
            // console.log(response.data)
            // return;
            window.open(response.data.url, "_top");
          } else {
            this.$store.commit("common/" + "ADD_ALERT", {
              type: "error",
              text: response.data.message || "Произошла ошибка!"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {}
};
</script>
<style scoped>
.form-border {
  border-width: 0;
  border-color: rgb(0, 94, 255);
  border-radius: 20px;
  border-style: solid;
  font-size: 25px;
}

.not-found__name {
  display: block;
  font-weight: bold;
  font-size: 96px;
  text-align: center;
}
.not-found__text {
  display: block;
  font-weight: bold;
  font-size: 48px;
  text-align: center;
}

.not-found__btn-container {
  display: flex;
  justify-content: center;
}

.not-found__btn {
  margin-top: 25px;
  display: block;
}
</style>
